import React, { useState, useEffect, useCallback } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { Container, Fight, FightsContainer, CustomLink } from './styles';
import { useHeader } from '../../hooks/Header';
import fightApiV2 from '../../services/fightApiV2';

interface Fighter {
  id: number;
  firstName: string;
  lastName: string;
  nickname: string;
  pictures: string;
}

interface Fight {
  id: string;
  redCorner: Fighter;
  blueCorner: Fighter;
}

interface EventsProps {
  match: {
    params: {
      id: string;
    };
  };
}

const Events: React.FC<EventsProps> = ({ match }) => {
  const [fights, setFights] = useState<Fight[]>([]);
  const [loading, setLoading] = useState(true);
  const { dispatchHeader } = useHeader();

  const fetchFights = useCallback(async () => {
    setLoading(true);
    dispatchHeader({
      title: 'Lutas',
      eventName: '',
      leftBg: {
        r: 42,
        g: 42,
        b: 42,
        a: 1,
      },
      rightBg: {
        r: 255,
        g: 255,
        b: 255,
        a: 1,
      },
      hasLogout: true,
      isScout: false,
    });
    try {
      const response = await fightApiV2.get(
        `/fights?eventId=${match.params.id}`,
        {
          headers: {
            per_page: 30,
            page: 1,
          },
        },
      );

      const eventResponse = await fightApiV2.get(`/events/${match.params.id}`);

      dispatchHeader({
        title: 'Lutas',
        eventName: eventResponse.data.name || '',
        leftBg: {
          r: 42,
          g: 42,
          b: 42,
          a: 1,
        },
        rightBg: {
          r: 255,
          g: 255,
          b: 255,
          a: 1,
        },
        hasLogout: true,
        isScout: false,
      });

      setFights(response.data.data ?? []);
    } catch (err) {
      toast.error('Fetch Event Fights failed.');
    } finally {
      setLoading(false);
    }
  }, [match.params.id, dispatchHeader]);

  useEffect(() => {
    fetchFights();
  }, [fetchFights]);

  return (
    <Container>
      <ToastContainer />
      <CustomLink to="/events">Events</CustomLink>
      {!loading && !fights.length && <span>Fights not found.</span>}
      {loading ? (
        <SkeletonTheme color="#1111" highlightColor="#d3d3d3">
          <Skeleton height={150} width={400} count={9} />
        </SkeletonTheme>
      ) : (
        <FightsContainer>
          {fights.map((f: Fight) => (
            <Fight key={f.id}>
              <span className="red-corner">
                {`
                ${f.redCorner?.firstName || 'null'}
                "${f.redCorner?.nickname || 'null'}"
                ${f.redCorner?.lastName || 'null'}`}
              </span>
              <span>vs</span>
              <span className="blue-corner">
                {`${f.blueCorner?.firstName || 'null'}
                  "${f.blueCorner?.nickname || 'null'}"
                 ${f.blueCorner?.lastName || 'null'}`}
              </span>

              <CustomLink to={`/fights/${f.id}`}>Scout!</CustomLink>
            </Fight>
          ))}
        </FightsContainer>
      )}
    </Container>
  );
};

export default Events;
